import {Search} from 'lucide-react';
import {PhoneHQSortHeader, PhoneHQAvatar, PhoneHQIconAvatar, PhoneHQButton, PhoneHQGlyph, PhoneHQInput, PhoneHQLoader, PhoneHQTooltip} from 'ch3-ui-lib';
import {  useIntl } from "react-intl";
import { useCallback, useEffect, useState } from "react";
import {Link} from "react-router-dom";
import {useSelector} from "react-redux";
import noGroupsIcon from '../../assets/empty-groups.svg';
import listEmpty from '../../assets/no-groups.svg';
import { debounce } from "lodash";
import useMediaQuery from "../../utilis/screenWidthUtils.ts";
import {
    FetchGroupsResponse,
    useFetchGroupsAdminQuery,
    useFetchGroupsQuery
} from "../../store/features/groups/groupsService";
import {buildQueryParams} from "../../utilis/buildQueryParams";
import {Msisdn, MsisdnSelectItem} from "../../store/features/Msisdns/msisdnService";
import {selectUserId} from "../../store/features/Auth/authSlice";
import {useLocation} from "react-router-dom";
import AdminPanelRestrictedView from "../../components/AdminPanelRestrictedView/AdminPanelRestrictedView";
import CallFiltersPanel from "../../components/Filters/CallFiltersPanel.tsx";
import {getFormatedPhoneNumber, getFlag} from "../../utilis/msisdnUtilis.ts";
import { FlagImage } from "react-international-phone";

interface GroupListProps {
    admin: boolean;
}
export default function GroupList({admin = false}: GroupListProps) {

    const [isFetching, setIsFetching] = useState(false);
    const [isSearching, setIsSearching] = useState(false);
    const role = useSelector((state: any) => state.auth.role);

    const isMobile = useMediaQuery('(max-width: 960px)');

    const userId = useSelector(selectUserId);

    const [groups, setGroups] = useState<FetchGroupsResponse[]>([]);
    const [totalGroups, setTotalCount] = useState(0);

    const [phrase, setPhrase] = useState<string>('');

    const [phoneNumbersFilter, setPhoneNumbersFilter] = useState<MsisdnSelectItem[]>([]);
    const [sort, setSort] = useState<any>({});
    const [groupsQuery, setGroupsQuery] = useState<any>({});

    const intl = useIntl();
    const name = intl.formatMessage({ id: 'groups.name' });
    const phoneNumber = intl.formatMessage({ id: 'groups.users' });
    const sharedFor = intl.formatMessage({ id: 'groups.phone-numbers' });

    const msisdns = phoneNumbersFilter.map((phoneNumber: MsisdnSelectItem) => phoneNumber.msisdn);
    const order = sort?.order;
    const sortBy = sort?.property;

    const getGroupsQuery = buildQueryParams({
        phrase,
        msisdns,
        order,
        sortBy,
        ...groupsQuery,
        userId,
        isAdmin: role == 'ADMIN' || role == 'SUPERADMIN'
    });

    const { data: groupsData, isLoading, isFetching: isUserFetching } = useFetchGroupsQuery(getGroupsQuery, { skip: admin });
    const { data: adminGroupsData, isLoading: isAdminLoading, isFetching:isAdminFetching } = useFetchGroupsAdminQuery(getGroupsQuery, { skip: !admin });

    const location = useLocation();
    const isAdminPath = location.pathname.includes('admin');


    useEffect(() => {
        setGroups([]);
        setTotalCount(0);
        setGroupsQuery({});
    }, [admin]);


    useEffect(() => {
        const currentData = admin ? adminGroupsData : groupsData;

        if (currentData) {
            setGroups(currentData.groups);
            setTotalCount(currentData.totalCount);
        }
        setIsSearching(false);
    }, [admin, groupsData, adminGroupsData]);



    const handleDataChange = (value: string) => {
        setIsSearching(true);
        setGroups([]);
        setGroupsQuery({});

        handlePhraseChange(value);
    };

    const handlePhraseChange = useCallback(
        debounce((phrase: string) => {
            setPhrase(phrase);
        }, 1000), // 1 second delay
        []
    );

    const handleDataSortChange = (order: string, property?: string) => {
        setGroupsQuery({});
        setSort({
            order,
            property
        });
    };


    const loadMore = () => {
        const currentData = admin ? adminGroupsData : groupsData;
        const lastGroup = currentData?.groups?.at(-1);

        setGroupsQuery({
            lastName: lastGroup?.group.name ,
            lastGroupId: lastGroup?.group.groupId
        });
    };

    const currentLoading = admin ? (isAdminLoading ?? false) : (isLoading ?? false);
    useEffect(() => {
        setIsFetching(isUserFetching || isAdminFetching);
    }, [isUserFetching, isAdminFetching]);

    return (
        <>
            {Boolean(role == 'USER') &&  isAdminPath &&
                <AdminPanelRestrictedView></AdminPanelRestrictedView>
            }
            {currentLoading &&
                <div className={`flex w-full  ${isMobile ? ' px-4' : ''}`}>
                    <PhoneHQLoader/>
                </div>

            }
            {!currentLoading &&
                <div className='w-full '>


                    <div className={`  ${isMobile ? ' px-4' : ' '}`}>
                        <div className={`flex justify-between items-center py-3 px-8 no-wrap border-b border-line `}>
                            <CallFiltersPanel
                                items={['PHONE_NUMBERS']}
                                admin={admin}
                                handlers={{onPhoneNumbersChange: setPhoneNumbersFilter}}
                                selectedPhoneNumbers={phoneNumbersFilter}
                            />
                            <PhoneHQInput phq-id={`groupList-searchInput`} value={phrase}  placeholder={'Search'} containerClassName={`${isMobile ? ' ' : ' min-w-[375px]'}`}  prefixIcon={<Search size={16} aria-hidden="true" className="!p-0"/>}  onChange={({target: {value}}) => handleDataChange(value)} onClear={() => handleDataChange('')}/>
                        </div>

                        <div className={`h-[calc(100vh-61px-var(--header-height))] overflow-y-auto `}>
                            <div className={' w-full ' + 'bg-surface'}>
                                {/* <p className={`text-lg font-semibold px-4 py-5 ` + 'border-line'} ><FormattedMessage

                        id='groups.list'/>
                        <span className={`bg-brand text-white  rounded-sm px-2 text-xs mx-2 py-1 ` + 'border-line'}>
        {totalGroups}
        </span>

                    </p> */}

                                {Boolean(groups.length) && <table className={` w-full border-b ` + 'border-line'}>

                                    <thead>
                                    <tr className={`border-b ` + 'border-line'} >
                                        <th className='pl-8 py-3 w-full'
                                        ><PhoneHQSortHeader label={name} propertyName='NAME' onSort={handleDataSortChange}/></th>
                                        <th className='min-w-[300px] '
                                        ><PhoneHQSortHeader label={phoneNumber}/></th>
                                        <th className='min-w-[200px]'
                                        ><PhoneHQSortHeader label={sharedFor}/></th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {groups.map((groupData: FetchGroupsResponse, index: number) => {
                                            return (
                                                <tr className={`border-t border-line hover:bg-canvas` } key={index}>
                                                    <Link to={admin ? `/admin/groups/details/${groupData.group.groupId}` : `/groups/details/${groupData.group.groupId}`}
                                                          className='no-underline block min-w-[250px]'>


                                                        <td className='flex gap-3 font-semibold  items-center pl-8 py-4'><PhoneHQIconAvatar icon={groupData.group?.icon} color={groupData.group?.iconColor} size="40px"/>
                                                            <div className="w-[200px] truncate">{groupData.group.name}</div>
                                                        </td>
                                                    </Link>


                                                    <td >
                                                        <div className=" justify-start gap-3 items-center flex">
                                                            {
                                                                groupData.users?.slice(0, 10).map((user, index) => (
                                                                    <PhoneHQTooltip content={user.firstName + ' ' + user.lastName}><div  style={{right: `${index * 20}px`}}
                                                                                       className={`p-[2px] bg-surface relative`}>
                                                                            <PhoneHQAvatar key={index} src={user.avatarUrl} name={user.firstName + ' ' + user.lastName} size="32px"/>
                                                                        </div></PhoneHQTooltip>

                                                                ))}
                                                            {
                                                                groupData.users?.length > 10 &&
                                                                <div
                                                                    style={{right: `170px`}}
                                                                    className={`relative  w-10`}
                                                                >
                                                                    {`+` + ` ${groupData.users?.length - 10}`}


                                                                </div>
                                                            }


                                                        </div>
                                                    </td>
                                                    <td className={'flex gap-3 mr-4 items-center min-w-[320px]'}>
                                                        {groupData.msisdns.slice(0, 10).map((el: Msisdn, index) => (
                                                            <PhoneHQTooltip content={
                                                                    <div className="flex flex-col items-center">
                                                                        <div className="text-xs mb-2">{el.label}</div>
                                                                        <div className="flex gap-1 items-center">
                                                                            <FlagImage size={16} className="w-3 h-3" iso2={getFlag(el.msisdn) ?? 'us'} />
                                                                            <div className="text-xs">{getFormatedPhoneNumber(el.msisdn, true)}</div>
                                                                        </div>
                                                                    </div>
                                                                }><div  style={{right: `${index * 20}px`}}
                                                                               className={`p-[2px] bg-surface relative`}>
                                                                    <PhoneHQIconAvatar key={index} icon={el.icon} color={el.iconColor} size="32px"/>
                                                                </div></PhoneHQTooltip>
                                                        ))}


                                                        {
                                                            groupData.msisdns.length > 10 && <div
                                                                style={{right: `170px`}}
                                                                className={`relative  w-10`}
                                                            >
                                                                {`+` + ` ${groupData.msisdns?.length - 10}`}


                                                            </div>
                                                        }



                                                    </td>

                                                </tr>
                                            )
                                        }
                                    )}

                                    </tbody>

                                </table>}


                                {groups.length === 0  && phrase &&                                    <div className={`flex text-center  justify-center  border-b ` + 'border-line'}>
                                        <div className='w-[450px]  m-14'>
                                            <div className='flex  justify-center w-full'>
                                                <img className='m-4' src={noGroupsIcon}/>
                                            </div>

                                            <h1 className='font-bold'>
                                                No groups found
                                            </h1>
                                            {Boolean(isAdminPath) &&

                                                <div className='mb-6 mt-2'>
                                                    No groups found matching your search. Please double-check your criteria.
                                                </div>
                                            }
                                            {Boolean(!isAdminPath) &&

                                                <div className='mb-6 mt-2'>
                                                    No groups found matching your search. Please double-check your criteria or consider
                                                    adding new groups to expand your network!
                                                </div>
                                            }
                                            {admin &&
                                                <div className='flex justify-center'>
                                                    <Link to={'/admin/groups/details/new'}>
                                                        <PhoneHQButton phq-id='groupList-createNewFromSearchBtn'><PhoneHQGlyph name='add' size={16}/>Create new group</PhoneHQButton>
                                                    </Link>

                                                </div>
                                            }
                                        </div>

                                    </div>

                                }
                                {
                                    (isFetching || isSearching) &&
                                    <div className='flex overflow-hidden max-h-[calc(100vh-61px-var(--header-height))]  justify-center'>
                                        <PhoneHQLoader/>
                                    </div>
                                }
                                {(Boolean(groups.length) && groups.length != totalGroups) &&
                                    <div className='flex justify-center my-4'>
                                        <PhoneHQButton variant="secondary-contrast" size="sm" onClick={loadMore} phq-id='groupList-loadMoreBtn'><PhoneHQGlyph name='more_horiz' size={16}/>Load more</PhoneHQButton>
                                    </div>
                                }
                            </div>
                            {!totalGroups && !phrase &&
                                <div className={`flex text-center  justify-center  border-b ` + 'border-line bg-surface'}>
                                    <div className='w-[450px]  m-14'>
                                        <div className='flex  justify-center w-full'>
                                            <img className='m-4' src={listEmpty}/>
                                        </div>
                                        {Boolean(isAdminPath) &&
                                            <h1 className='font-bold'>
                                                No groups yet!
                                            </h1>
                                        }
                                        {Boolean(!isAdminPath) &&
                                            <h1 className='font-bold'>
                                                No groups available
                                            </h1>
                                        }
                                        {Boolean(isAdminPath) &&
                                            <div className='mb-6 mt-2'>
                                                Click below to add one now.
                                            </div>
                                        }
                                        {Boolean(!isAdminPath) &&
                                            <div className='mb-6 mt-2'>
                                                You are not currently assigned to any groups.                                </div>
                                        }
                                        {admin &&
                                            <div className='flex justify-center'>
                                                <Link to={'/admin/groups/details/new'}>
                                                    <PhoneHQButton phq-id='groupList-createNewNoGroupsBtn'><PhoneHQGlyph name='add' size={16}/>Create new</PhoneHQButton>
                                                </Link>
                                            </div>
                                        }
                                    </div>

                                </div>

                            }

                        </div>

                    </div>

                </div>
            }
        </>
    );
}
